<img src="/assets/img/logo-globe.jpg" style="display:none" (load)="CheckOnload()" />
@for (data of this.JumboInspection; track data; let i = $index) {
  <div
    style="margin-bottom:70px;margin-top: 10px; position: relative;">
    <table class="companytable">
      <tr>
        <td>
          <div class="container1">
            <div class="image">
              <img src="/assets/img/logo-globe.jpg" />
            </div>
            <div class="text">
              <b style="text-transform: uppercase;">{{ Company.CompanyName }}</b>
              <p style="font-size: 12px; margin: 0;">{{Company.Address}}</p>
              @if (ActiveDocumentVersion) {
                <div style="text-align: right; width: 100%; margin-top: 2px; line-height: 1;">
                  <span style="font-size: 10px;">{{ActiveDocumentVersion.FormatNo}}, Rev No.
                  {{ActiveDocumentVersion.VersionNo}}</span>
                </div>
              }
            </div>
          </div>
          <div class="company">
            <table style="border-top: 1px solid; border-bottom: 1px solid; margin-top: 10px ">
              <b>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>ROLL NUMBER:</b></td>
                  <td style="padding-left:10px"><b>{{data.Code}}</b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>ITEM NAME:</b></td>
                  <td style="padding-left:10px"><b>{{JumboData.ITEMNAME}}</b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>P.CODE/GRAIN:</b></td>
                  <td style="padding-left:10px"><b>{{JumboData.PRODUCTCODE}} / {{JumboData.GRAIN}}</b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>COLOUR/FINISH:</b></td>
                  <td style="padding-left:10px"><b>{{JumboData.COLOUR}} / {{JumboData.FINISH}} </b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>THICKNESS:</b></td>
                  <td style="padding-left:10px"><b>{{JumboData.THICKNESS}}</b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>WIDTH:</b></td>
                  <td style="padding-left:10px"><b>{{JumboData.WIDTH}}</b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>ROLL LENGTH:</b></td>
                  <td style="padding-left:10px"><b>{{data.Quantity }} </b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"> <b>GRADE:</b></td>
                  <td style="padding-left:10px"><b>{{data.Grade}}</b></td>
                </tr>
                <tr>
                  <td style=" border-right: 1px solid; text-align: center;"><b>INSPECTED BY:</b></td>
                  <td style="padding-left:10px"><b>{{data.InspectedBy}}</b></td>
                </tr>
                <!-- Batch Number Row - Only show if barcode data available -->
                @if (shouldShowBarcode() && getBatchNumber()) {
                  <tr>
                    <td style=" border-right: 1px solid; text-align: center;"><b>BATCH NO:</b></td>
                    <td style="padding-left:10px"><b>{{getBatchNumber()}}</b></td>
                  </tr>
                }
              </b>
            </table>
            <b>
              <p style="font-size:12px; text-transform: uppercase;"><b>Please examine the goods before cutting. We don't
              accept any claim on cut goods. In case of complaints, please return with the labels.</b></p>
            </b>
            <!-- Horizontal Divider (only show if barcode data available) -->
            @if (shouldShowBarcode()) {
              <div class="horizontal-divider"></div>
            }
            <!-- Horizontal Barcode and QR Code Section -->
            @if (shouldShowBarcode()) {
              <div class="horizontal-barcode-section">
                <!-- Barcode on Left -->
                <div class="barcode-container-horizontal">
                  <svg [id]="'inspection-barcode-horizontal-' + i" class="barcode-svg-horizontal"></svg>
                  <!-- ShortCode positioned below barcode -->
                  @if (data.LabelShortCode) {
                    <div class="shortcode-bottom-right">
                      {{data.LabelShortCode}}
                    </div>
                  }
                </div>
                <!-- QR Code on Right -->
                <div class="qr-code-container-horizontal">
                  <div class="qr-code-wrapper-horizontal">
                    <nz-qrcode [nzValue]="getQRCodeData(data)" [nzSize]="80" [nzBordered]="false" [nzLevel]="'M'">
                    </nz-qrcode>
                  </div>
                </div>
              </div>
            }
          </div>
        </td>
      </tr>
    </table>
  </div>
}